import React from 'react';
import PropTypes from 'prop-types';

import RadioGroupContainer from '../../RadioGroupContainer';
import RadioButtonAttribute from '../RadioButtonAttribute';

class RulesContainer extends React.Component {
  onRulesChange = (keyPath, field) => {
    ['required', 'hidden'].forEach((curr) => {
      this.props.onFieldValueChange([...keyPath, curr], (field === curr));
    });
  }

  render() {
    return (
      <RadioGroupContainer radioGroupName={this.props.radioGroupName} disabled={this.props.disabled}>
        <RadioButtonAttribute
          disabled={this.props.disabled}
          field="none"
          keyPath={this.props.keyPath}
          label="None"
          onRadioButtonChange={this.onRulesChange}
          radioGroupName={this.props.radioGroupName}
          value={(!this.props.values.required && !this.props.values.hidden)}
        />
        <RadioButtonAttribute
          disabled={this.props.disabled}
          field="required"
          keyPath={this.props.keyPath}
          label="Required"
          onRadioButtonChange={this.onRulesChange}
          radioGroupName={this.props.radioGroupName}
          value={this.props.values.required}
        />
        <RadioButtonAttribute
          disabled={this.props.disabled}
          field="hidden"
          keyPath={this.props.keyPath}
          label="Hidden"
          onRadioButtonChange={this.onRulesChange}
          radioGroupName={this.props.radioGroupName}
          value={this.props.values.hidden}
        />
      </RadioGroupContainer>
    );
  }
}

RulesContainer.propTypes = {
  disabled: PropTypes.bool,
  keyPath: PropTypes.array.isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
  radioGroupName: PropTypes.string.isRequired,
  values: PropTypes.shape({
    required: PropTypes.bool.isRequired,
    hidden: PropTypes.bool.isRequired,
  }).isRequired,
};

RulesContainer.defaultProps = {
  disabled: false,
};

export default RulesContainer;
